var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "sidebar-cart__list-item",
      class: {
        "sidebar-cart__list-item--editable": _vm.editable,
        "sidebar-cart__list-item--restricted": _vm.restricted
      }
    },
    [
      _c("div", { staticClass: "sidebar-cart__list-item-info" }, [
        _c("div", { staticClass: "sidebar-cart__list-item-info-wrapper" }, [
          _c("span", {
            staticClass: "sidebar-cart__list-item-name",
            domProps: {
              innerHTML: _vm._s(_vm.item.detailedName || _vm.item.name)
            }
          }),
          _vm._v(" "),
          _vm.item.variant && !_vm.item.detailedName
            ? _c("span", {
                staticClass: "sidebar-cart__list-item-meta",
                domProps: { innerHTML: _vm._s(_vm.item.variant) }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.hasFeature("FEATURE_CART_ITEM_NOTES") && !_vm.item.disableNote
          ? _c(
              "button",
              {
                staticClass: "sidebar-cart__list-item-notes",
                class: {
                  "sidebar-cart__list-item-notes--active": _vm.item.notes
                },
                attrs: {
                  title: _vm.item.notes
                    ? _vm.$t("cart.notes.buttonTitleActive")
                    : _vm.$t("cart.notes.buttonTitleEmpty"),
                  disabled: _vm.locked || !_vm.editable || _vm.restricted
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("notes")
                  }
                }
              },
              [_c("SVGNote")],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("QuantityCounter", {
        attrs: {
          quantity: _vm.item.quantity,
          locked: _vm.locked || !_vm.editable || _vm.restricted,
          "base-class": "sidebar-cart__list-item-quantity"
        },
        on: {
          sub: function($event) {
            return _vm.$emit("sub")
          },
          add: function($event) {
            return _vm.$emit("add")
          }
        }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "sidebar-cart__list-item-price",
        domProps: {
          innerHTML: _vm._s(
            _vm.$options.filters.fwgpricecent(_vm.item.originalTotal, "short")
          )
        }
      }),
      _vm._v(" "),
      _vm.item.description
        ? _c("div", { staticClass: "sidebar-cart__list-item-details" }, [
            _c("div", {
              staticClass: "sidebar-cart__list-item-description",
              domProps: { innerHTML: _vm._s(_vm.item.description) }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }